module.exports = __webpack_public_path__ + "img/img-form-productos.f1549591.png";